import React, { PropTypes } from 'react'

import { getProperty, nl2br } from '../utils'

import Button from './button'

const responsiveModes = {
    stack: 'table--stack-mobile',
}

export default function Table(props) {
    const tableClassName = [ 'table' ]
    const headerCellClassName = [ 'table-head-cell' ]
    const dataCellClassName = [ 'table-cell' ]

    if (props.responsive) {
        tableClassName.push(responsiveModes[props.responsive])
    }

    if (props.onRowClick) {
        tableClassName.push('table--clickable')
    }

    return (
        <table className={ tableClassName.join(' ') }>
            { props.noHeaders !== true &&
                <thead>
                    <tr className="table-head-row">
                        { props.columns.map((column) => (
                            <th
                                className={ headerCellClassName.concat(column.className || []).join(' ') }
                                key={ column.key }
                            >
                                { column.header }
                            </th>
                        )) }
                    </tr>
                </thead>
            }
            <tbody>
                { props.data.length ?
                    props.data.map((item, itemIndex) => {
                        const rowProps = {}

                        if (props.onRowClick) {
                            rowProps.onClick = () => props.onRowClick(item, itemIndex)
                        }

                        return (
                            <tr
                                { ...rowProps }
                                className="table-row"
                                key={ itemIndex }
                            >
                                { props.columns.map((column, columnIndex) => (
                                    <td
                                        className={ dataCellClassName.concat(column.className || []).join(' ') }
                                        data-header={ column.header }
                                        key={ `${ itemIndex }.${ columnIndex }` }
                                    >
                                        { column.display ?
                                            column.display(item, itemIndex, column.key) :
                                            getProperty(item, column.key, column.default || '')
                                        }
                                    </td>
                                )) }
                            </tr>
                        )
                    }) :
                    <tr className="table-row">
                        <td className="table-cell table-cell--centered" colSpan={ props.columns.length }>
                            Sorry, no items found.
                        </td>
                    </tr>
                }
            </tbody>
        </table>
    )
}

Table.propTypes = {
    columns: PropTypes.arrayOf(
        PropTypes.shape({
            default: PropTypes.string,
            display: PropTypes.func,
            header: PropTypes.string,
            key: PropTypes.string.isRequired,
        })
    ).isRequired,
    data: PropTypes.arrayOf(PropTypes.object).isRequired,
    noHeaders: PropTypes.bool,
    onRowClick: PropTypes.func,
    responsive: PropTypes.string,
}

Table.defaultProps = {
    noHeaders: false,
}

Table.deleteButton = function deleteButtonFactory(callback) {
    return (item) => (
        <Button
            buttonOnly
            onClick={ (e) => {
                e.preventDefault()
                e.stopPropagation()

                // eslint-disable-next-line no-alert
                if (confirm('Are you sure you wish to delete this item?')) {
                    callback(item)
                    return
                }
            } }
            small
            status="delete"
            transparent
        >
            Delete
        </Button>
    )
}

Table.boolean = (item, index, key) => item[key] ? '✓' : '✗'
Table.nl2br = (item, index, key) => nl2br(item[key])



// WEBPACK FOOTER //
// ./app/components/ui/table.js